import React from 'react';

const ListContext = React.createContext({
  onClick: () => {},
});

export default ListContext;
